import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Canada = () => {
    return <SharedDocumentsComponent permissionId="37" path="Canadá" />
}